import styled from "styled-components";
import Img from "../../../../../assets/images/landing_page_pallet1.png";
import Img1 from "../../../../../assets/images/Homepage_Expertise-Solutions.jpg";
import Img2 from "../../../../../assets/images/3Rectangle.jpeg";
const Container = styled.div``;
const Wrapper = styled.div`
  h1,
  h2,
  h3,
  h4 {
    font-family: ITC Franklin Gothic Std;
  }
  @media (max-width: 767px) {
      h1, h2{
        font-size: 1.5rem !important;
      }
    }
  /* padding: min(2.45vw, 35px) 0; */
  p{
    font-size: 1.5rem;
  }
  h1, h2 {
    font-size: 2.759rem;
  }
  max-width: 1440px;
  margin: 0 auto;
  position: relative;
  button {
    background-color: #233354;
    font-weight: 400;
    color: rgb(255, 255, 255);
    border: none;
    margin-top: min(1.75vw, 25px);
    font-size: 14px;
    padding: 8px 20px;
    width: 250px;
  }
  h1,
  h2,
  h3,
  h4 {
    font-family: "ITC Franklin Gothic Std";
  } 
  @media (max-width: 1024px){
    p{
      font-size: 17px;
    }
    h1, h2{
      font-size: 1.7rem;
    }
  }
  .banner {
    background-image: url(${Img});
    width: 100%;
    position: relative;
    /* background-size: contain; */
    background-repeat: no-repeat;
    background-position: top;
    .quote {
      position: fixed;
      z-index: 99;
      top: 400px;
      right: 0;
      @media (min-width: 1441px) {
        margin-right: calc(50vw - 726px);
      }
      @media (max-width: 1023px) {
        top: 310px;
      }
      @media (max-width: 767px) {
        top: 394px;
      }
      &.search_inventory {
        position: absolute;
        z-index: 99;
        bottom: 92px;
        right: 0;
      }
      button {
        background-color: #ff0000c7;
        color: #fff;
        border: none;
        padding: 12px;
        font-size: 16px;
        width: 155px;
        @media (max-width: 767px) {
          top: 0px;
        }
      }
    }

    .banner-text {
      background: linear-gradient(
        90deg,
        rgba(9, 34, 46, 0.711922268907563) 52.3%,
        rgba(255, 255, 255, 0) 52.3%
      );
      height: 550px;
      /* padding: 16px; */
      color: #ffffff;
      display: flex;
      justify-content: flex-start;
      .need{
        text-align: left;
      }
      .text-wrp {
        display: flex;
        align-items: flex-start;
        justify-content: center;
        flex-direction: column;
        text-align: center;
        margin-left: 3.25vw;
        /* h2 {
          font-size: 2rem;
        } */

        p {
          font-size: 1.5rem;
          margin: 2px;
        }
      }
    }
    @media (max-width: 1024px) {
      background-size: cover;
      .banner-text {
        height: 350px;
        background: linear-gradient(
          90deg,
          rgba(9, 34, 46, 0.711922268907563) 56%,
          rgba(255, 255, 255, 0) 56%
        );
        .text-wrp {
          /* margin-left: 1.25vw;*/
          /* margin-bottom: 62px;  */
          margin-bottom: 38px;
          h1, h2 {
            font-size: 1.4rem;
            margin-top: -2px;
          }
          p {
            font-size: 17px;
            margin: 2px;
          }
        }
      }
      .quote {
        &.search_inventory {
          bottom: 54px;
        }
        button {
          padding: 8px;
          font-size: 14px;
          width: 155px;
        }
      }
    }

    /* @media only screen 
  and (min-device-width: 360px) 
  and (max-device-width: 412px) 
  and (min-device-height: 740px) 
  and (max-device-height: 846px) 
  and (-webkit-device-pixel-ratio: 4) {

    
 } */
    @media only screen and (min-device-width: 1024px) and (max-device-width: 1024px) and (min-device-height: 1366px) and (max-device-height: 1366px) and (-webkit-device-pixel-ratio: 2),
      only screen and (min-device-width: 1024px) and (max-device-width: 1024px) and (min-device-height: 1366px) and (max-device-height: 1366px) and (min-resolution: 192dpi) and (max-resolution: 264dpi) {
      .quote {
        top: 270px;
      }
    }
    @media (max-width: 360px) {
      .banner-text {
        height: 410px !important;
        .text-wrp {
          margin-bottom: 33px !important;
          h1, h2{
            font-size: 2rem !important;
            display: contents;
          }
          p{
            font-size: 21px !important;
          }
        }
        .need{
          display: block;
          margin-bottom: 24px;
          padding-right: 6px;
        }
      }
      .quote {
        top: 406px !important;
      }
    }
    @media only screen and (min-width: 360px) and (max-width: 767px) {
      .text-wrp h1,h2,p{
        text-align: left;
      }
     }

    @media (max-width: 767px) {
      background-size: cover;
      .banner-text {
        height: 410px;
        background: linear-gradient(
          90deg,
          rgba(9, 34, 46, 0.711922268907563) 100%,
          rgba(255, 255, 255, 0) 50%
        );
        justify-content: center;
        h1,h2{
          font-size: 1.8rem !important;
          display: contents;
        }
        .need{
        display: block;
        margin-bottom: 24px;
        /* padding-right: 6px; */
        }
        .text-wrp {
          margin-bottom: 62px;
          text-align: left;
          margin: 3.25vw;
          p{
            font-size: 21px;
            display: contents;
          }
        }
      }
      .quote {
        /* bottom: 118px; */
        &.search_inventory {
          bottom: 34px;
        }
        button {
          padding: 4px;
          font-size: 11px;
          width: 132px;
        }
      }
    }
  }
  .simplify_process {
    /* padding: 0 0 min(2.45vw, 35px) 0; */
    /* margin-top: 2.8vw;
    margin-bottom: 60px; */
    margin: 4vw 0;
    background-color: #e9ecec;
    ul li:before {
      content: "✓";
      margin-right: 16px;
    }
    .box-3-wrp {
      display: grid;
      grid-template-columns: repeat(3, 1fr);
      gap: 2rem;
      @media (max-width: 1023px) {
        gap: 1rem;
      }
      @media (max-width: 767px) {
        grid-template-columns: 1fr;
        gap: 1rem;
        padding: 0 16px;
      }
      .box-info {
        background-color: #233354;
        display: grid;
        grid-template-rows: 1fr auto;
        li {
          /* list-style: disc; */
          margin-left: 16px;
          display: flex;
          align-items: baseline;
          .list-box {
            /* display: grid;
            grid-template-columns: 1fr 20px; */
            span {
              font-size: 1.5rem;
              font-weight: 600;
              @media (max-width: 767px){
                font-size: 1.2rem;
              }
            }
          }
          button {
            margin: 0;
            padding: 0;
            width: auto;
            /* margin-left: 20px; */
          }

          .collapsible-content {
            transition: max-height 0.5s ease-in-out, opacity 0.5s ease-in-out;
            overflow: hidden;
            /* border: 1px solid; */
            border-radius: 4px;
            /* margin: 12px 0;
            padding: 4px 12px; */
            margin: 0px 0 20px;
            padding: 4px 0px;
            p {
              margin: 0;
              font-size: 19px;
              @media(max-width: 767px){
              font-size: 14px;
            }
            }
           
          }

          .ReactCollapse--collapse {
            transition: max-height 0.5s ease-in-out;
            grid-column: 1 / span 2;
          }

          .ReactCollapse--content {
            transition: opacity 0.5s ease-in-out;
            grid-column: 1 / span 2;
          }
        }
      }
    }
    .simplify_process_titel {
      padding: 1.2rem;
      h2 {
        text-align: center;
        color: #233354;
        font-weight: 400;
      }
    }

    .img-bg {
      background-color: #e3f1fb;
      padding: 26px;
      display: flex;
      justify-content: center;
      min-height: 206px;
      border: 2px solid #233354;
    }
    .text-bg {
      /* background-color: #233354; */
      /* color: #ffffff; */
      /* color: #f4fafd; */
      background-color: #f4fafd;
      /* padding: 20px 16px 16px 16px; */
      display: grid;
      justify-content: center;
      text-align: center;
      ul {
        text-align: left;
        margin-bottom: 0;
        padding: 20px 16px 16px 16px;
        color: #0e5789;
      }
      h4 {
        margin-bottom: 25px;
        font-size: 38px;
        background-color: #233354;
        color: #ffffff;
        padding: 20px 16px 16px 16px;

      }
      @media (max-width: 1023px) {
        h4 {
          font-size: 25px;
        }
      }
      @media (max-width: 767px) {
        h4 {
          font-size: 1.5rem;
        }
        ul{
          padding-top: 0;
        }
      }
      @media only screen and (device-width: 390px) and (device-height: 844px) and (-webkit-device-pixel-ratio: 3) {
        h4 {
          font-size: 32px;
        }
        li {
          font-size: 18px;
        }
      }
    }
    .item-center-box {
      display: flex;
      justify-content: center;
      background-color: #ffffff;
      padding-bottom: min(2.45vw, 35px);
      @media (max-width: 1024px) {
        button {
          margin-top: 29px;
          margin-bottom: 11px;
        }
      }
    }
    @media (max-width: 767px) {
      button {
        margin-bottom: 10px;
        margin-top: 18px;
      }
    }
    @media (max-width: 1024px) {
      .img-bg {
        padding: 16px;
        min-height: 170px;
        img {
          max-width: 132px;
        }
      }
    }
    @media only screen and (device-width: 390px) and (device-height: 844px) and (-webkit-device-pixel-ratio: 3) {
      .img-bg {
        padding: 16px !important;
        min-height: 170px !important;
        img {
          max-width: 160px !important;
        }
      }
    }

    @media (max-width: 767px) {
      .simplify_process_titel {
        padding: 22px 12px;
        h2 {
          font-size: 1.5rem !important;
        }
      }
      .img-bg {
        padding: 16px;
        min-height: 100px;
        img {
          max-width: 152px;
        }
      }
    }
  }

  .our_expertise {
    background-image: url(${Img1});
    width: 100%;
    background-repeat: repeat;
    background-position: right;
    background-size: cover;
    &.suppliers {
      background-image: url(${Img2});
      background-size: cover;
    }
    .expertise_overlay {
      background: linear-gradient(109deg, #ee0000bf 50%, transparent 50%);
      height: 700px;
      color: #ffffff;
      padding: 16px;
      padding-left: 6.25vw;
      display: flex;
      flex-direction: column;
      justify-content: center;
      &.expert{
        background:linear-gradient(109deg, #b40001e3 50%, transparent 50%);
         height: 650px;
         @media (max-width: 767px) {
          height: 300px !important;
          background: linear-gradient(109deg, #ee0000c4 100%, transparent 100%);
         }
         @media (max-width: 1024px){
          height: 400px;
         }
      } 
      .max-w {
        max-width: 370px;
        margin-top: 42px;
        @media (max-width: 1024px) {
          max-width: 311px;
          margin-top: 13px;
        }
        @media (max-width: 767px){
         p{
          margin-top: 18px;
        } 
        }
        @media (max-width: 767px){
         p{
          margin-top: 18px;
        } 
        }
      }
      .grid {
        display: grid;
        button {
          background-color: #ffffff;
          color: #ee0000;
          width: 270px;
          font-weight: 600;
          @media (max-width: 767px){
              width: 310px;
          }
        }
      }
    }
    @media (max-width: 1024px) {
      .expertise_overlay {
        height: 500px;
        padding-left: 4.25vw;
        h2{
          font-size: 1.7rem;
        }
      }
    }
    @media (max-width: 767px) {
      background-size: cover;
      margin: 5.5vw 3.5vw !important;
      width: auto;
      .expertise_overlay {
        background: linear-gradient(109deg, #ee0000c4 100%, transparent 100%);
        height: 357px;
        justify-content: center;
        align-items: center;
        h2 {
          font-size: 20px;
        }
        p {
          font-size: 14px;
        }
      }
    }
  }
  .digital_supplier {
    display: grid;
    grid-template-columns: 1fr 1fr;
    /* margin: 60px 0; */
    margin: 4vw 0;
    .digital_supplier_img {
      background-color: #e3f1fb;
      /* padding: 3vw 16px 3vw 6.25vw; */
      img {
        max-width: 100%;
      }
    }
    .digital_supplier-text {
      /* background-color: #233354; */
      background-color: #e3f1fb;
      /* color: #ffffff; */
      color: #233354;
      padding: 20px;
      display: grid;
      place-items: center;
      div {
        max-width: 410px;
      }
      h2 {
        margin-bottom: 40px;
      }
      button {
        background-color: #233354;
        color: #ffffff;
        font-weight: 600;
      }
    }

    @media (max-width: 767px) {
      grid-template-columns: 1fr;
      margin: 5.5vw 3.5vw !important;
      width: auto;
      .digital_supplier_img {
        /* padding: 16px; */
        display: flex;
        justify-content: center;
      }
      .digital_supplier-text {
        h2 {
          font-size: 20px;
          margin-bottom: 20px;
        }
        p {
          font-size: 14px;
        }
      }
    }
  }
  .search_marketplace {
    padding: 2vw 16px;
    padding-top: 4vw;
    display: grid;
    justify-content: center;
    text-align: center;
    h2 {
      color: #233354;
    }
    .flex {
      gap: 3vw;
      display: flex;
      margin-top: 30px;
      @media (max-width: 1023px) {
        button {
          width: 215px;
        }
      }
    }
    @media (max-width: 767px) {
      padding: 7vw 16px;
      h2 {
        font-size: 1.7rem !important;
        display: contents;
      }
      .experience{
        margin-top: 6px;
      }

      .flex {
        gap: 3vw;
        display: flex;
        margin-top: 30px;
        flex-direction: column;
        justify-content: center;
        align-items: center;
      }
    }
  }
  @media (max-width: 1024px) {
    h2 {
      font-size: 1.7rem;
    }
    h4 {
      font-size: 1rem;
    }
    li {
      font-size: 14px;
    }
  }
`;

export { Container, Wrapper };
